import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FileCheck, ListChecks, UserCircle, LifeBuoy, LogOut } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import StatusBadge from "../components/StatusBadge";

export default function DashboardPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [richieste, setRichieste] = useState([]);

  useEffect(() => {
    api.get("/agibilita/mie").then((res) => setRichieste(res.data)).catch(() => {});
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const ultima = richieste[0];
  const inCorso = richieste.filter((r) => ["RICHIESTA RICEVUTA", "IN LAVORAZIONE"].includes(r.stato)).length;

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8" data-testid="dashboard-page">
      <div className="rounded-xl bg-gradient-to-r from-[#6E2138] via-[#8A2440] to-[#9E2A43] px-6 py-8 text-white shadow-lg shadow-bordeaux/25 animate-fade-up sm:px-10">
        <p className="text-xs font-semibold uppercase tracking-widest text-gold">Area Personale</p>
        <h1 className="mt-2 font-heading text-3xl font-bold sm:text-4xl" data-testid="dashboard-welcome">
          BENVENUTO/A {user?.nome?.toUpperCase()}
        </h1>
        <p className="mt-2 text-sm text-white/70">
          {user?.nome} {user?.cognome} · {user?.email}
        </p>
      </div>

      <div className="mt-8 grid gap-6 md:grid-cols-3">
        <div className="card-elegant" data-testid="dashboard-profile-card">
          <div className="flex items-center gap-3">
            <UserCircle className="h-6 w-6 text-bordeaux" />
            <h2 className="font-heading text-lg font-semibold text-bordeaux-dark">Il tuo profilo</h2>
          </div>
          <dl className="mt-4 space-y-2 text-sm">
            <div><dt className="text-muted-foreground">Nome e Cognome</dt><dd className="font-medium">{user?.nome} {user?.cognome}</dd></div>
            <div><dt className="text-muted-foreground">Email</dt><dd className="font-medium">{user?.email}</dd></div>
            <div><dt className="text-muted-foreground">Codice Fiscale</dt><dd className="font-medium tracking-wider">{user?.codice_fiscale}</dd></div>
          </dl>
        </div>

        <div className="card-elegant" data-testid="dashboard-requests-count-card">
          <div className="flex items-center gap-3">
            <FileCheck className="h-6 w-6 text-bordeaux" />
            <h2 className="font-heading text-lg font-semibold text-bordeaux-dark">Richieste di agibilità</h2>
          </div>
          <p className="mt-4 font-heading text-4xl font-bold text-bordeaux" data-testid="dashboard-requests-count">
            {richieste.length}
          </p>
          <p className="text-sm text-muted-foreground">richieste effettuate</p>
          <p className="mt-2 text-sm text-muted-foreground">
            <span className="font-semibold text-foreground">{inCorso}</span> in corso di lavorazione
          </p>
        </div>

        <div className="card-elegant" data-testid="dashboard-status-card">
          <div className="flex items-center gap-3">
            <ListChecks className="h-6 w-6 text-bordeaux" />
            <h2 className="font-heading text-lg font-semibold text-bordeaux-dark">Stato richieste</h2>
          </div>
          {ultima ? (
            <div className="mt-4 space-y-2 text-sm">
              <p className="text-muted-foreground">Ultima pratica: <span className="font-semibold text-foreground">{ultima.numero_pratica}</span></p>
              <StatusBadge stato={ultima.stato} />
              <div>
                <Link to={`/le-mie-richieste/${ultima.id}`} className="text-sm font-semibold text-bordeaux hover:underline" data-testid="dashboard-last-request-link">
                  Vedi dettagli
                </Link>
              </div>
            </div>
          ) : (
            <p className="mt-4 text-sm text-muted-foreground">Non hai ancora inviato richieste. Inizia ora con la tua prima richiesta di agibilità.</p>
          )}
        </div>
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Link to="/richiedi-agibilita" data-testid="dashboard-request-btn" className="btn-bordeaux !py-4">
          <FileCheck className="h-4 w-4" /> RICHIEDI CERTIFICATO DI AGIBILITÀ
        </Link>
        <Link to="/le-mie-richieste" data-testid="dashboard-my-requests-btn" className="btn-outline-bordeaux !py-4">
          <ListChecks className="h-4 w-4" /> LE MIE RICHIESTE
        </Link>
        <Link to="/profilo" data-testid="dashboard-profile-btn" className="btn-outline-bordeaux !py-4">
          <UserCircle className="h-4 w-4" /> IL MIO PROFILO
        </Link>
        <Link to="/assistenza" data-testid="dashboard-support-btn" className="btn-outline-bordeaux !py-4">
          <LifeBuoy className="h-4 w-4" /> ASSISTENZA
        </Link>
      </div>
      <button onClick={handleLogout} data-testid="dashboard-logout-btn" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-bordeaux hover:underline">
        <LogOut className="h-4 w-4" /> ESCI
      </button>
    </div>
  );
}
